export default __webpack_public_path__ + "static/media/00.9ec17867.jpg";